




































import { Component, Mixins, Vue, Ref } from 'vue-property-decorator'
import InputSimple from '@/components/common/atoms/InputSimple.vue'
import SelectBase, { SelectOption } from '@/components/common/atoms/SelectBase.vue'
import ButtonBase from '@/components/common/atoms/ButtonBase.vue'
import FileDropArea from '@/components/common/atoms/FileDropArea.vue'
import LinkArea from '@/components/admin/organisms/LinkArea.vue'
import MarkerTable from '@/components/admin/organisms/MarkerTable.vue'
import ModalMarkerAdd from '@/components/admin/organisms/ModalMarkerAdd.vue'
import ModalNicknameUpdate from '@/components/academy/organisms/ModalNicknameUpdate.vue'
import ModalPasswordUpdate from '@/components/academy/organisms/ModalPasswordUpdate.vue'
import ModalSubjectUpdate from '@/components/admin/organisms/ModalSubjectUpdate.vue'
import MarkerListApis, { MarkersData, MarkerSearchQuery } from '@/mixins/requests/admin/MarkerListApis.vue'
import PaginationButton from '@/components/common/organisms/PaginationButton.vue'

@Component({
  components: {
    InputSimple,
    SelectBase,
    ButtonBase,
    FileDropArea,
    LinkArea,
    MarkerTable,
    ModalMarkerAdd,
    ModalNicknameUpdate,
    ModalPasswordUpdate,
    ModalSubjectUpdate,
    PaginationButton,
  },
})
export default class MarkerList extends Mixins(MarkerListApis) {
  private markerId = ''
  private nickname = ''
  private subjectCode = ''
  private bcbtCode!: string
  private markersData: MarkersData[] = []
  private currentQuery: MarkerSearchQuery = {}
  private subjectOptions: SelectOption[] = []
  /* ページネーション中の検索か判断するフラグ */
  private isPaginationSearch = false

  // ref: 採点者追加モーダル
  @Ref() modalMarkerAdd!: ModalMarkerAdd
  // ref: 氏名変更モーダル
  @Ref() modalNicknameUpdate!: ModalNicknameUpdate
  // ref: 教科変更モーダル
  @Ref() modalSubjetUpdate!: ModalSubjectUpdate
  // ref: パスワード変更モーダル
  @Ref() modalPasswordUpdate!: ModalPasswordUpdate
  // ref: ページネーション
  @Ref() paginationButton!: PaginationButton

  private async mounted(): Promise<void> {
    Vue.prototype.$loading.start()
    try {
      this.subjectOptions = await this.subjectNameList()
    } catch {
      alert('エラーが発生しました')
    } finally {
      await this.loadMarkersList()
      Vue.prototype.$loading.complete()
    }
  }

  /**
   *採点者追加モーダル表示
   */
  private onClickMarkerAddButton(): void {
    this.modalMarkerAdd.showModal(this.subjectOptions)
  }

  /**
   * 採点者追加処理 (モーダルからイベント検知)
   */
  private async markerAdminAdd(nickname: string, password: string, subjectCodes: string[]): Promise<void> {
    Vue.prototype.$loading.start()
    try {
      await this.markerAdminAddApi(nickname, password, subjectCodes)
    } catch (err: any) {
      if (err.response.data.status === 400) {
        this.modalMarkerAdd.setErrorMessage(err.response.data.message)
      } else {
        alert('エラーが発生しました')
      }
    } finally {
      await this.loadMarkersList()
      Vue.prototype.$loading.complete()
    }
  }

  /**
   * 氏名変更モーダル表示
   */
  private onClickNicknameUpdateButton(bcbtCode: string): void {
    this.bcbtCode = bcbtCode
    this.modalNicknameUpdate.init()
    this.modalNicknameUpdate.show()
  }

  /**
   * 氏名変更処理 (モーダルからイベント検知)
   */
  private async markerNicknameUpdate(): Promise<void> {
    Vue.prototype.$loading.start()
    try {
      await this.userNicknameUpdateApi(this.bcbtCode, this.modalNicknameUpdate.nickname)
      this.modalNicknameUpdate.hide()
    } catch (err: any) {
      if (err.response.data.status === 400) {
        this.modalNicknameUpdate.setErrorMessage(err.response.data.message)
      } else {
        alert('エラーが発生しました')
      }
    } finally {
      await this.loadMarkersList()
      Vue.prototype.$loading.complete()
    }
  }

  /**
   * 教科変更モーダル表示
   */
  private async onClickSubjectUpdateButton(bcbtCode: string) {
    this.bcbtCode = bcbtCode
    this.modalSubjetUpdate.showModal(this.subjectOptions)
  }

  /**
   * 教科変更処理 (モーダルからイベント検知)
   */
  private async markerSubjectUpdate(subjectCodes: string[]): Promise<void> {
    Vue.prototype.$loading.start()
    try {
      await this.markerSubjectUpdateApi(this.bcbtCode, subjectCodes)
    } catch (err: any) {
      if (err.response.data.status === 400) {
        alert('割当済みの設問が存在する教科が含まれます。割当解除してから教科設定を変更してください。')
      } else {
        alert('エラーが発生しました')
      }
    } finally {
      await this.loadMarkersList()
      Vue.prototype.$loading.complete()
    }
  }

  /**
   * パスワード変更モーダル表示
   */
  private onClickPasswordUpdateButton(bcbtCode: string): void {
    this.bcbtCode = bcbtCode
    this.modalPasswordUpdate.init()
    this.modalPasswordUpdate.show()
  }

  /**
   * パスワード変更処理 (モーダルからイベント検知)
   */
  private async markerPasswordUpdate(): Promise<void> {
    Vue.prototype.$loading.start()
    try {
      await this.userPasswordUpdateApi(
        this.bcbtCode,
        this.modalPasswordUpdate.password,
        this.modalPasswordUpdate.comfirmPassword
      )
      this.modalPasswordUpdate.hide()
    } catch (err: any) {
      if (err.response.data.status === 400) {
        this.modalPasswordUpdate.setErrorMessage(err.response.data.message)
      } else {
        alert('エラーが発生しました')
      }
    } finally {
      await this.loadMarkersList()
      Vue.prototype.$loading.complete()
    }
  }

  /**
   * 採点者削除処理
   */
  private async onClickDeleteButton(bcbtCode: string): Promise<void> {
    // 取込処理
    this.bcbtCode = bcbtCode
    if (confirm('削除しますか？')) {
      Vue.prototype.$loading.start()
      try {
        await this.userDeleteApi(this.bcbtCode)
        this.modalPasswordUpdate.hide()
      } catch (err: any) {
        if (err.response.data.status === 400) {
          alert('割当済みの設問が存在します。割当解除してから削除してください。')
        } else {
          alert('エラーが発生しました')
        }
      } finally {
        await this.loadMarkersList()
        Vue.prototype.$loading.complete()
      }
    }
  }

  /**
   * 絞り込みボタン
   */
  private async onClickSearch(): Promise<void> {
    Vue.prototype.$loading.start()
    try {
      this.search()
    } finally {
      Vue.prototype.$loading.complete()
    }
  }

  /**
   * 採点者検索処理
   */
  private async search(): Promise<void> {
    this.currentQuery = {}

    if (this.markerId == '' && this.nickname == '' && this.subjectCode == '') {
      this.isPaginationSearch = false
    } else {
      this.isPaginationSearch = true
    }

    if (this.markerId) {
      this.currentQuery.bcbtCode = this.markerId
    }

    if (this.nickname) {
      this.currentQuery.nickname = this.nickname
    }

    if (this.subjectCode) {
      this.currentQuery.subjectCode = this.subjectCode
    }

    await this.loadMarkersList()
  }

  /**
   * 採点者情報取得
   */
  private async loadMarkersList() {
    // 検索時用のページネーションデータ取得
    if (this.isPaginationSearch) {
      const markersObject = await this.searchMarkersApi(this.paginationButton.paginationCurrentPage, this.currentQuery)
      this.markersData = markersObject.responses
      this.paginationButton.paging(markersObject.pagination)
    }

    // 通常のページネーションデータ取得
    if (!this.isPaginationSearch) {
      const markersObject = await this.markersListApi(this.paginationButton.paginationCurrentPage)
      this.markersData = markersObject.responses
      this.paginationButton.paging(markersObject.pagination)
    }
  }

  private async onClickPaginationButton() {
    await this.loadMarkersList()
  }
}
